/**
 * Знак платформы — зелёный лист. Цвет фирменный (#6EB74A), одинаково читается
 * в светлой и в тёмной теме, поэтому наследование цвета ему не нужно.
 */
export function Logo({ height = 28, label }: { height?: number; label?: string }) {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.6011 13.3031C72.2107 15.7235 75.0447 20.2942 76.1037 27.0153C66.6667 28.6105 60.3106 27.3147 57.0351 23.1278C53.7596 18.9409 51.8495 14.565 51.3047 10C59.4371 10.431 64.8692 11.532 67.6011 13.3031Z"
        fill="#6EB74A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.1378 85.4414C67.6527 85.4414 84.2873 69.2364 84.2873 49.2386C84.2873 38.3088 76.8743 28.9961 71.4592 21.8711C80.2873 28.6444 87.9763 39.7276 87.9763 52.409C87.9763 72.8411 70.9902 89.4047 50.0357 89.4047C35.4874 89.4047 22.8492 81.4194 16.4844 69.6966C23.1802 79.2042 34.4117 85.4414 47.1378 85.4414Z"
        fill="#6EB74A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0433 23.7178C21.9946 26.7276 19.5742 30.313 17.9226 34.2659C16.2709 38.2188 15.4209 42.4604 15.422 46.7445C15.422 64.7717 30.2169 79.3873 48.4682 79.3873C56.3708 79.4052 64.0198 76.5996 70.0365 71.4761C66.9071 74.9693 63.0747 77.7615 58.7905 79.6695C54.5063 81.5775 49.8671 82.5582 45.1772 82.5473C26.8535 82.5473 12 67.8731 12 49.7717C12 39.1488 17.1149 29.7068 25.0433 23.7178Z"
        fill="#6EB74A"
      />
    </svg>
  );
}
